import { render, staticRenderFns } from "./before-after-images-filter.vue?vue&type=template&id=5fc6afe3"
import script from "./before-after-images-filter.vue?vue&type=script&lang=ts"
export * from "./before-after-images-filter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports